import Logo from '../../../img/logo.png';
import logo_white from '../../../img/logo_white.png';


export const MAIN_NUMBER = '022 815-819';
export const OTHER_NUMBERS = ['079 815-819', '060 815-819'];
export const WORKING_HOURS = 'working_hours';
export const LOGO_PATH = Logo;
export const LOGO_PATH_DARK= logo_white

export const LANGUAGES = [
    {code: 'ru', label: 'RU'},
    {code: 'ro', label: 'RO'}
];

export const PAGES = [
    {path: "delivery", labelKey: "delivery"},
    {path: "payment", labelKey: "payment"},
    {path: "bonuses", labelKey: "bonuses"},
    {path: "promotion", labelKey: "promo"},
];

